import React from 'react';
import propTypes from 'prop-types';
import { Button } from 'reactstrap';
import classNames from 'classnames';
import { Toolbars as ToolBarContainer } from '../../components/Card/CardHeaderWithToolbars';

const Toolbars = ({ isOpen, onToggleFilter, onRefreshList, onResetFilter }) => (
  <ToolBarContainer>
    <Button
      type="button"
      title="Refresh"
      aria-label="Refresh"
      color="info"
      size="sm"
      className="with-toolbars__toolbars__btn"
      onClick={onRefreshList}
    >
      <i className="fa fa-refresh"></i>
    </Button>
    <Button
      type="button"
      title="Reset filter"
      aria-label="Reset filter"
      color="warning"
      size="sm"
      className="with-toolbars__toolbars__btn"
      onClick={onResetFilter}
    >
      <i className="fa fa-ban"></i>
    </Button>
    <Button
      type="button"
      title="Search and Filter Data"
      aria-label="Search and filter"
      size="sm"
      className={classNames('with-toolbars__toolbars__btn', { 'btn-danger': isOpen })}
      onClick={onToggleFilter}
    >
      <i className={classNames('fa', { 'fa-sliders': !isOpen, 'fa-minus': isOpen })}></i>
    </Button>
  </ToolBarContainer>
);

Toolbars.propTypes = {
  isOpen: propTypes.bool,
  onToggleFilter: propTypes.func.isRequired,
  onRefreshList: propTypes.func.isRequired,
  onResetFilter: propTypes.func.isRequired,
};

Toolbars.defaultProps = {
  isOpen: false,
};

export default Toolbars;
